function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

function getRedirectOnFail() {
    var params = new URLSearchParams(window.location.search);
    var utm_source = params.get("utm_content");
    var locale = document.body.getAttribute("data-locale");
    var redirect = "/";

    if(utm_source === null) {
        return redirect;
    }

    var urls = {
        samsung: locale == "si" ? "/dodatna-oprema-samsung" : "/samsung",
        apple: locale == "si" ? "/dodatna-oprema-apple" : "/apple",
        xiaomi: locale == "si" ? "/dodatna-oprema-xiaomi" : "/xiaomi",
        huawei: locale == "si" ? "/dodatna-oprema-huawei" : "/huawei",
        oneplus: locale == "si" ? "/dodatna-oprema-oneplus" : "/oneplus",
        lg: locale == "si" ? "/dodatna-oprema-lg" : "/lg",
        sony: locale == "si" ? "/dodatna-oprema-sony" : "/sony",
        nokia: locale == "si" ? "/dodatna-oprema-nokia" : "/nokia"
    };

    if(utm_source.indexOf("Samsung") !== -1) {
        redirect = urls.samsung;
    } else if(utm_source.indexOf("iPhone") !== -1) {
        redirect = urls.apple;
    } else if(utm_source.indexOf("Xiaomi") !== -1) {
        redirect = urls.xiaomi;
    } else if(utm_source.indexOf("Huawei") !== -1) {
        redirect = urls.huawei;
    } else if(utm_source.indexOf("OnePlus") !== -1) {
        redirect = urls.oneplus;
    } else if(utm_source.indexOf("_LG_") !== -1) {
        redirect = urls.lg;
    } else if(utm_source.indexOf("Sony") !== -1) {
        redirect = urls.sony;
    } else if(utm_source.indexOf("Nokia") !== -1) {
        redirect = urls.nokia;
    } else {
        redirect = "/";
    }

    return redirect;
}

var url = '/identify/category' + window.location.search;
if(window.location.search.indexOf("type=") !== -1) {
    url = '/identify/get-redirect' + window.location.search;
}

var xhr = new XMLHttpRequest();
xhr.open('POST', url, true);
xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
xhr.onreadystatechange = function() {
    var DONE = 4;
    var OK = 200;
    if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
            var response = JSON.parse(xhr.responseText);
            var redirect = response.midCatUrl;

            if(redirect === null) {
                redirect = getRedirectOnFail();
                if(getQueryVariable("promo") !== false) {
                    redirect = decodeURIComponent(getQueryVariable("promo"));
                }
            }

            if(redirect.indexOf('?') === -1) {
                redirect += '?' + window._queryString;
            }
            else {
                redirect += '&' + window._queryString;
            }
            console.log(redirect);
            window.location.href = redirect;
            // for (var i in response) {
            //     var p = document.createElement("p");
            //     p.innerHTML = i + " - " + response[i];
            //     document.body.insertBefore(p, document.body.firstChild);
            // }

            // var p = document.createElement("p");
            // p.innerHTML = navigator.userAgent;
            // document.body.insertBefore(p, document.body.firstChild);
        } else {
            console.log(getRedirectOnFail());
            window.location.href = getRedirectOnFail();
        }
    }
};

var xhrAgent = new XMLHttpRequest();
xhrAgent.open('GET', "/identify/device/user-agent" + window.location.search, true);
xhrAgent.setRequestHeader("Content-type", "application/json");
xhrAgent.onreadystatechange = function() {
    var DONE = 4;
    var OK = 200;
    if (xhrAgent.readyState === DONE) {
        if (xhrAgent.status === OK) {
            var response = JSON.parse(xhrAgent.responseText);
            var params = 'userAgent=' + response.userAgent;
            window._queryString = response.queryString;
            xhr.send(params);
        }
    }
};
xhrAgent.send();
